import React from "react";
import "./PlayerList.css";
import "./AllButtons.css";

// Here I am using the way of importing props by destructuring
export default function PlayerList({ players, deletePlayer }) {
  return (
    <>
      {players.map((player) => {
        console.log(player.color);
        // I don't know why, but this appears to be necessary
        // Putting style={{player.color}} doesn't work for some reason
        let color = player.color;
        let backgroundColor = {
          backgroundColor: player.color
        }
        return (
          <div className="playerDiv">
            <p key={player.id} style={{ color }} className="player">
              {player.name}
            </p>
              <button
                style={backgroundColor}
                className="Button DeleteButton"
                onClick={() => deletePlayer(player.id)}

              >
                Delete
              </button>
          </div>
        );
      })}
    </>
  );
}
